import { message } from "ant-design-vue";
import Request from "../libs/request";
import Tool from "../libs/tool";
import SwiperMove from "@/comment/components/swiper/index.vue";
import Header from "@/comment/components/header/index.vue";

export default function init(app) {
  app.config.globalProperties.$message = message;
  app.config.globalProperties.$http = new Request();
  app.config.globalProperties.$tools = Tool;
  // 数据列表展示
  app.component("swiper-move", SwiperMove);
  // 头部通用组件
  app.component("header-layer", Header);
}
